
define(
  'ContactExtensions.EntryPoint'
  , [
    'ContactExtensions.Model',
    'Profile.Model'
  ]
  , function (
    ContactExtensionsModel,
    ProfileModel
  ) {
    'use strict';

    return {
      mountToApp: function mountToApp(container) {

        /** @type {LayoutComponent} */
        var layout = container.getComponent('Layout');
        var environment = container.getComponent('Environment');
        var config = environment && environment.getConfig('ContactExtensions');

        if(layout && config && config.enable) {
          ProfileModel.getPromise().done(function (profile) {
            if (!profile || profile.isLoggedIn !== 'T') {
              return;
            }
            try {
              var contactExtensionsModel = new ContactExtensionsModel();
              contactExtensionsModel.fetch({
                async: false
              }).done(function (result) {
                if(result && result.firstname) {
                  var fullName = result.firstname;
                  if(result.lastname) {
                    fullName += ' ' + result.lastname;
                  }
                  layout.addToViewContextDefinition('Header.Profile.View', 'displayName', 'string', function () {
                    return fullName;
                  });
                }
              });
            } catch (e) {
              console.log(e);
            }
          });
        }

      }
    };
  });
